import React from 'react'
import { Activity } from 'lucide-react'
import GenericTable from '../../components/GenericTable'

const AdminApiLogs = () => {
  return (
    <GenericTable
        tableName="api_logs"
        title="API Logs"
        icon={Activity}
        iconColor="teal"
        searchFields={['user_email', 'api_type', 'method', 'endpoint', 'response_status']}
        hiddenFields={['idx', 'user_id', 'query_params', 'request_headers', 'response_headers', 'request_body', 'response_body']}
        primaryKey="id"
        defaultFields={['id', 'user_email', 'api_type', 'method', 'endpoint', 'response_status', 'response_time_ms', 'ip_address', 'user_agent', 'created_at']}
        addFields={['user_email', 'api_type', 'method', 'endpoint', 'response_status', 'response_time_ms', 'ip_address', 'user_agent']}
        editFields={[
          'user_email', 'api_type', 'method', 'endpoint', 'response_status', 
          'response_time_ms', 'ip_address', 'user_agent'
          // Excluded: id, idx, user_id, created_at, query_params, request_headers, response_headers, request_body, response_body
        ]}
      />
  )
}

export default AdminApiLogs
